<template>
    <div v-if="reservationList.length == 0">
        <div class="emphasis">
            <div class="emphasis--icon">
                <img v-if="$store.state.hospStore.hostNm == '대동맥혈관병원'" src="/resource/icon/emphasis-icon01.svg" class="" alt="">
                <img v-else-if="$store.state.hospStore.hostNm == '뇌혈관병원'" src="/resource/icon/emphasis-icon01-brain.svg" class="" alt="">
                <img v-else-if="$store.state.hospStore.hostNm == '엄마아기병원'" src="/resource/icon/emphasis-icon01-mom.svg" class="" alt="">
                <img v-else-if="$store.state.hospStore.hostNm == '혈액암병원'" src="/resource/icon/emphasis-icon01-blood.svg" class="" alt="">
            </div>
            <h3 class="title02">
                "예약된 진료내역이 없습니다."
            </h3>
        </div>
    </div>
    <div v-else>
        <div class="info">
            <ul class="reservation-table__bottom">
                <li>
                    <img v-if="$store.state.hospStore.hostNm == '대동맥혈관병원'" src="@/assets/resource/icon/last-year--mark.svg" class="" alt="">
                    <img v-else-if="$store.state.hospStore.hostNm == '뇌혈관병원'" src="@/assets/resource/icon/last-year--mark--brain.svg" class="" alt="">
                    <img v-else-if="$store.state.hospStore.hostNm == '엄마아기병원'" src="@/assets/resource/icon/last-year--mark.svg" class="" alt="">
                    <img v-else-if="$store.state.hospStore.hostNm == '혈액암병원'" src="@/assets/resource/icon/last-year--mark-blood.svg" class="" alt="">
                    <p class="title03">진료 예약</p>
                </li>
                <li>
                    <img v-if="$store.state.hospStore.hostNm == '대동맥혈관병원'" src="@/assets/resource/icon/this-year--mark.svg" class="" alt="">
                    <img v-else-if="$store.state.hospStore.hostNm == '뇌혈관병원'" src="@/assets/resource/icon/this-year--mark--brain.svg" class="" alt="">
                    <img v-else-if="$store.state.hospStore.hostNm == '엄마아기병원'" src="@/assets/resource/icon/this-year--mark--mom.svg" class="" alt="">
                    <img v-else-if="$store.state.hospStore.hostNm == '혈액암병원'" src="@/assets/resource/icon/this-year--mark--blood.svg" class="" alt="">
                    <p class="title03">검사 예약</p>
                </li>
            </ul>
            <div class="reservation-table">
                <div :class="{'last-year': idx == 0, 'this-year': idx > 0}" v-for="(year, idx) in years">
                    <div class="reservation-table__top">
                        <h4 class="title03">{{year.year}}</h4>
                    </div>
                    <ul class="reservation-table__list01">
                        <li class="reservation-table__item" v-for="month in year.months">
                            <div class="reservation-table__point" v-for="reservation in reservationList" :class="'day-' + new Date(reservation.MED_DT).getDate()">
                                <span class="mark" v-if="dateCheck(reservation.MED_DT, year.year, month)"></span>
                                <ul class="mark-hover" v-if="dateCheck(reservation.MED_DT, year.year, month)">
                                    <li><b>외래 예약일</b> : {{setInfoDate(reservation, 'N')}}</li>
                                    <li><b>진료과</b> : {{reservation.DEPT_NM}}</li>
                                    <li><b>진료의</b> : {{reservation.MED_NM}}</li>
                                </ul>
                            </div>
                        </li>
                    </ul>
                    <ul class="reservation-table__list02">
                        <li class="reservation-table__item" v-for="month in year.months">
                            <div class="reservation-table__point" v-for="inspect in inspectList" :class="'day-' + new Date(inspect.RSV_DTM).getDate()">
                                <span class="mark" v-if="dateCheck(inspect.RSV_DTM, year.year, month)"></span>
                                <ul class="mark-hover" v-if="dateCheck(inspect.RSV_DTM, year.year, month)">
                                    <li><b>검사 예약일</b> : {{inspect.RSV_DTM}}</li>
                                    <li><b>검사명</b> : {{inspect.EXRM_NM}}</li>
                                    <li><b>예약검사실</b> : {{inspect.EXRM_TP_NM}}</li>
                                </ul>
                            </div>
                        </li>
                    </ul>
                    <ul class="reservation-table__title">
                        <li class="reservation-table__item" v-for="month in year.months">{{month}}월</li>
                    </ul>
                </div>
            </div>
           
        </div>
        <div class="info">
            <div class="reservation">
                <div class="reservation-bar-wrap">
                    <span class="reservation-bar" ></span>
                </div>
                <ul class="reservation-list">
                    <li class="reservation-item" v-for="reservation in reservationList">
                        <div class="doctor-list__item">
                            <div class="doctor-list--img">
                                <!-- <img :src="`/displayFile.do?attachNo=${ reservation.docInfo.attachBag.thumbs[0].attachNo }`" :alt="reservation.docInfo.attachBag.thumbs[0].altValue || '이미지'" v-if="reservation.docInfo.attachBag.thumbs"> -->
                                <img :src="`/displayFile.do?drSid=${ reservation.MEDR_SID }`" alt="이미지" onerror="this.style.display='none'">
                            </div>
                            <div class="doctor-list--con">
                                <div class="doctor-list--text">
                                    <h3 class="doctor-list--name">{{reservation.MED_NM}} 교수</h3>
                                    <p class="doctor-list--department">{{reservation.docInfo.belong}}</p>
            
                                    <h4 class="doctor-list--clinic" v-if="reservation.docInfo.detailField">전문진료분야</h4>
                                    <p class="doctor-list--desc">{{reservation.docInfo.detailField}}</p>
                                </div>
                                <div class="doctor-list--button">
                                    <a :href="`/kr/doctorInfo?drSid=${reservation.docInfo.drSid}&deptCd=${reservation.docInfo.mainDeptCd}`" target="_blank">의료진 소개</a>
                                </div>
                            </div>
                        </div>
                        <div class="mark"></div>
                        <div class="reservation-item__con">
                            <h4 class="title02">{{setInfoDate(reservation, 'Y')}}</h4>
                            <div class="botton-wrap nowrap">
                                <a href="javascript:;" class="main-button c-main" @click="changeReservation(reservation)">예약변경</a>
                                <a href="javascript:;" class="sub-button c-main" @click="CancelReservation(reservation)">예약취소</a>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <kr_popup_change @successReservation="successReservation" ref="popupChange"></kr_popup_change>
    </div>
    <kr_popup_certification v-if="popupVisible" @cancelNameCheck="hidePopup"/>
 </template>
 
 <script>
     export default {
        data() {
            return {
                reservationList: [],
                inspectList: [],
                years: this.getYears(),

                popupVisible: false,
            }
        },
        mounted() {
            if(this.$commonUtils.isEmpty(this.$store.state.myInfoStore.ptNo)){
                this.$store.commit('setNiceType', '')
                this.popupVisible = true

                window.addEventListener("message", (event) => {
                    try {

                        if (event.data && event.data.source === "react-devtools-content-script") {
                            return;
                        }

                        const receivedData = JSON.parse(event.data); // JSON 파싱
                        if (receivedData.callFunction === "checkSuccess") {
                            this.checkSuccess(receivedData.data); // 데이터 전달
                        }
                    } catch (e) {
                        console.error("Invalid JSON data received:", e);
                    }
                });
            }

            this.fetchReservations()
            this.fetchInspect()
        },
        beforeDestroy() {
            // 컴포넌트가 제거되기 전 리스너를 제거
            window.removeEventListener('resize', this.onResize);  // 리사이즈 이벤트 제거
            window.removeEventListener('scroll', this.onScroll);  // 스크롤 이벤트 제거
        },
        methods: {
            showPopup() {
                this.popupVisible = true;
            },
            hidePopup() {
                this.popupVisible = false;
                this.$router.push('/kr/mypage/mypage')
            },
            checkSuccess(data){
                if(data.iReturn === 0 && data.ptNo !== '' && data.ptNo !== null){
                    // this.hidePopup()
                    this.popupVisible = false;
                    this.axios.get(this.api.member.info)
                        .then(res => {
                            if(res.data.ptNo) this.$store.state.myInfoStore.ptNo = res.data.ptNo;
                        })
                        .catch(err => {
                            console.error(err)
                        })
                }else{
                    alert(data.sMessage)
                }
            },
            dateCheck(dt, year, month){
                const date = new Date(dt)

                const dtYear = date.getFullYear()
                const dtMonth = date.getMonth() + 1

                const result = (year === dtYear && month === dtMonth);

                return result
            },
            getYears(){
                const currentDate = new Date();
                const currentYear = currentDate.getFullYear();
                const currentMonth = currentDate.getMonth();
                
                // 월 리스트 생성
                const getMonths = (year, startMonth = 0, endMonth = 11) => {
                    const months = [];
                    for (let i = startMonth; i <= endMonth; i++) {
                        // n월 형식
                        // months.push(new Date(year, i).toLocaleString('default', { month: 'long' }));
                        // 숫자 형식
                        months.push(new Date(year, i).getMonth() + 1)
                    }
                    return months;
                };
                
                // 1월인 경우
                if (currentMonth === 0) {
                    return [{ year: currentYear, months: getMonths(currentYear) }];
                }
                
                // 1월이 아닌 경우
                const yearsList = [
                    { year: currentYear, months: getMonths(currentYear, currentMonth) },
                    { year: currentYear + 1, months: getMonths(currentYear + 1, 0, currentMonth - 1) }
                ];
                
                return yearsList;
            },
            fetchReservations() {
                this.axios
                    .get(this.api.mypage.reservationList, {
                        params: {
                            IN_APY_DT: this.$commonUtils.addDate("d", 2, this.$commonUtils.getToday()),
                            IN_END_DT: this.$commonUtils.addDate("y", 1, this.$commonUtils.getToday()),
                            hospId: this.$store.getters.getHost
                        },
                    })
                    .then((res) => {
                        // this.reservationList = res.data.list.sort(function (a, b) {
                        //     return a.MED_DT - b.MED_DT
                        // })
                        this.reservationList = res.data.list.sort((a, b) => new Date(a.MED_DT) - new Date(b.MED_DT));

                        this.reservationList.forEach(item => {
                            res.data.doclist.forEach(doc => {
                                if (item.MEDR_SID === doc.drSid) {
                                    item.docInfo = doc
                                    return false
                                }
                            })
                        })

                        // DOM이 렌더링된 후에 실행되도록 nextTick 사용
                        this.$nextTick(() => {
                            this.setChildWidth();  // 컴포넌트가 마운트된 후 width 설정
                            this.addOnClassToSecondPoint();  // 모든 .reservation-table__point에서 두 번째 요소마다 'on' 클래스 추가
                            window.addEventListener('resize', this.onResize);  // 리사이즈 시에도 width 업데이트 및 클래스 추가
                            window.addEventListener('scroll', this.onScroll);  // 스크롤 시 높이 변경
                        });
                    })
                    .catch((err) => {
                        alert('예약 조회 중 오류가 발생했습니다.')
                    })
            },
            fetchInspect() {
                this.axios
                    .get(this.api.mypage.inspectList, {
                        params: {
                            IN_FROMDT: this.$commonUtils.addDate("d", 2, this.$commonUtils.getToday()),
                            IN_TODT: this.$commonUtils.addDate("y", 1, this.$commonUtils.getToday()),
                        },
                    })
                    .then((res) => {
                        this.inspectList = res.data
                    })
                    .catch((err) => {
                        alert('예약 조회 중 오류가 발생했습니다.')
                    })
            },
            setInfoDate(item, dayYn) {
                const days = ['일', '월', '화', '수', '목', '금', '토']
                const dayOfWeek = new Date(item.MED_DT).getDay()
                const week = days[dayOfWeek]

                const time = item.MED_DTM.slice(0, 2) + ':' + item.MED_DTM.slice(2, 4)

                const result = dayYn == 'Y' ? `${item.MED_DT} (${week}) ${time}` : `${item.MED_DT} ${time}`

                return result
            },
            changeReservation(item) {
                const info = item.docInfo
                info.RPY_PACT_ID = item.RPY_PACT_ID
                info.mainDeptCd = item.MED_DEPT_CD
                this.$refs.popupChange.info = info
                this.$refs.popupChange.popupBtn()
            },
            CancelReservation(item){
                if (confirm('예약을 취소하시겠습니까?')) {
                    const param = {
                        IN_PACT_ID : item.RPY_PACT_ID,
                        IN_MED_DEPT_CD : item.MED_DEPT_CD,
                    }

                    this.axios({
                        method: 'post',
                        url: this.api.mypage.reservationCancel,
                        params: param
                    }).then(res => {
                        if(res.data.errormsg){
                            alert(res.data.errormsg)
                            return
                        }
                        alert('예약이 취소되었습니다.')
                        this.fetchReservations()
                    }).catch(err => {
                        alert('오류가 발생했습니다.')
                        location.reload(true);
                    })
                }
            },
            setChildWidth() {
                const reservationTable = document.querySelector('.reservation-table');
                const items = document.querySelectorAll('.reservation-table__item');
    
                if (reservationTable && items.length > 0) {
                    const tableWidth = reservationTable.offsetWidth;  // 부모 요소의 너비
                    const itemWidth = tableWidth * 0.08333;  // 부모의 너비의 8.33% 크기 설정
    
                    items.forEach(item => {
                        item.style.width = `${itemWidth}px`;
                    });
                }
            },
            onResize() {
                this.setChildWidth();  // 리사이즈 시 width 업데이트
            },
            addOnClassToSecondPoint() {
                // 모든 .reservation-table__point 요소를 선택
                const points = document.querySelectorAll('.reservation-table__point');
                const itemList01 = document.querySelectorAll('.reservation-table__list01 .reservation-table__item');
                const itemList02 = document.querySelectorAll('.reservation-table__list02 .reservation-table__item');
                
                // points 배열을 순회하며 두 번째 요소마다 'on' 클래스 추가
                points.forEach((point, index) => {
                    if ((index + 1) % 2 === 0) {  // 두 번째, 네 번째, 여섯 번째 등의 요소에 대해
                        point.classList.add('on');
                    }
                });

                // .reservation-table__list01의 마지막 4개 항목에 'left' 클래스 추가
                const lastItemsList01 = Array.from(itemList01).slice(-4); // list01의 마지막 4개 항목
                lastItemsList01.forEach(item => {
                    item.classList.add('left');
                });

                // .reservation-table__list02의 마지막 4개 항목에 'left' 클래스 추가
                const lastItemsList02 = Array.from(itemList02).slice(-4); // list02의 마지막 4개 항목
                lastItemsList02.forEach(item => {
                    item.classList.add('left');
                });
            },
            onScroll() {
                const reservationBar = document.querySelector('.reservation-bar');
                if (reservationBar) {
                    // 현재 스크롤 위치 가져오기
                    const scrollPosition = window.scrollY || document.documentElement.scrollTop;
                    
                    // 최대 높이, 최소 높이 설정
                    const maxHeight = 5000;
                    const minHeight = 0;

                    const isMobile = window.innerWidth <= 720;

                    // newHeight 변수 선언 (if/else 블록 밖에서)
                    let newHeight;

                    // 스크롤 위치에 따라 높이 계산
                    if (isMobile) {
                        newHeight = Math.min(Math.max(minHeight + scrollPosition / 1 + 200, minHeight), maxHeight);
                    } else {
                        newHeight = Math.min(Math.max(minHeight + scrollPosition / 1 - 100, minHeight), maxHeight);
                    }

                    // 새 높이를 예약 바에 적용
                    reservationBar.style.setProperty('height', `${newHeight}px`, 'important');
                }
            },
            successReservation(){
                if(this.$route.path.indexOf('/selectReservation') > -1) this.$parent.fetchReservations()
                this.$router.push('/kr/mypage/reservation/selectReservation')
            },
        }
    }
</script>
 <style scoped></style>